import { useQuery } from "@tanstack/react-query";
import { getOrganisationSummary, getProjectSummary, SummaryShapeError } from "@/lib/api/summary";
import { shouldRetry } from "@/lib/providers";
import { useTenancy } from "@/lib/tenancy/tenancy-context";

/** A refused summary is a permanent answer: retrying only delays saying so. */
const retry = (count: number, error: Error) => !(error instanceof SummaryShapeError) && shouldRetry(count, error);

/** 2.976: the organisation's summary, over the projects the caller may see. */
export function useOrganisationSummary() {
  const { organisationId } = useTenancy();
  return useQuery({
    queryKey: ["summary", "organisation", organisationId],
    queryFn: () => getOrganisationSummary(organisationId),
    enabled: !!organisationId,
    retry,
    refetchInterval: 60_000,
  });
}

/** 2.976: the active project's summary. */
export function useProjectSummary() {
  const { projectId } = useTenancy();
  return useQuery({
    queryKey: ["summary", "project", projectId],
    queryFn: () => getProjectSummary(projectId),
    enabled: !!projectId,
    retry,
    refetchInterval: 60_000,
  });
}
